import get from 'lodash/get';
import CURRENCY_OPTIONS from './Options';


export function findCurrencyByValue(value) {
  return CURRENCY_OPTIONS.filter((option) => option.value === value)[0];
};

export function formatMoney(value, currency=null, options={}) {
  let withPrefix = get(options, 'withPrefix', true);
  let withTrailingZeros = get(options, 'withTrailingZeros', true);
  let native = get(options, 'native', false);

  if (!parseFloat(value) && parseFloat(value) !== 0) value = 0;

  let option = null;
  if (currency) option = CURRENCY_OPTIONS.filter((option) => option.value === currency)[0];
  if (!option) {
    if (withTrailingZeros) value = parseFloat(value).toFixed(2);
    if (withPrefix) return `$${value}`;
    return `${value}`;
  }

  let amt = parseFloat(value).toFixed(option.decimal_digits);

  // if no trailing zeros
  if (!withTrailingZeros) {
    let decimalAmt = 0;
    let splitAmt = amt.split(".");
    if (splitAmt.length > 1) decimalAmt = parseInt(splitAmt[1]);
    if (!decimalAmt) amt = splitAmt[0];
  }

  amt = amt.toLocaleString();
  if (!withPrefix) return `${amt}`;
  if (native) return `${option.symbol_native}${amt}`;
  return `${option.symbol}${amt}`;
};


export function getCurrencyOptions() {
  return CURRENCY_OPTIONS;
};
